import React from "react";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import ShowChartRoundedIcon from "@mui/icons-material/ShowChartRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import { NavItem } from "./types";

export const MAIN_NAV_ITEMS: NavItem[] = [
  {
    name: "Dashboard",
    exact: true,
    to: "/",
    icon: <GridViewRoundedIcon fontSize="small" />,
    hasChildren: false,
    childrenItems: [],
    testId: "dashboard-nav-item",
  },
  {
    name: "Accounts",
    exact: false,
    to: "/accounts",
    icon: <AccountBalanceRoundedIcon fontSize="small" />,
    hasChildren: false,
    childrenItems: [],
    testId: "accounts-nav-item",
  },
  {
    name: "Transactions",
    exact: true,
    to: "/transactions",
    icon: <ReceiptLongRoundedIcon fontSize="small" />,
    hasChildren: false,
    childrenItems: [],
    testId: "transactions-nav-item",
  },
  {
    name: "Investments",
    exact: false,
    to: "/investments",
    icon: <ShowChartRoundedIcon fontSize="small" />,
    hasChildren: false,
    childrenItems: [],
    testId: "investments-nav-item",
  },
];

export const MORE_NAV_ITEMS: NavItem[] = [
  {
    name: "Savings",
    exact: false,
    to: "/savings",
    icon: <SavingsRoundedIcon fontSize="small" />,
    hasChildren: false,
    childrenItems: [],
    testId: "savings-nav-item",
  },
  {
    name: "Liabilities",
    exact: false,
    to: "/liabilities",
    icon: <CreditCardRoundedIcon fontSize="small" />,
    hasChildren: false,
    childrenItems: [],
    testId: "liabilities-nav-item",
  },
];

export const NAVIGATION_ITEMS: NavItem[] = [
  ...MAIN_NAV_ITEMS,
  ...MORE_NAV_ITEMS,
];

export const SETTINGS_NAV: NavItem = {
  name: "Settings",
  exact: true,
  to: "/settings",
  icon: <SettingsRoundedIcon fontSize="small" />,
  hasChildren: false,
  childrenItems: [],
  testId: "settings-nav-item",
};
